var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_788_4790",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_788_4790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 12.5C7.14444 12.5 6.98611 12.4361 6.85833 12.3083C6.73056 12.1806 6.66667 12.0222 6.66667 11.8333C6.66667 11.6444 6.73056 11.4861 6.85833 11.3583C6.98611 11.2306 7.14444 11.1667 7.33333 11.1667H8.66667C8.85556 11.1667 9.01389 11.2306 9.14167 11.3583C9.26945 11.4861 9.33333 11.6444 9.33333 11.8333C9.33333 12.0222 9.26945 12.1806 9.14167 12.3083C9.01389 12.4361 8.85556 12.5 8.66667 12.5H7.33333ZM2.66667 5.83333C2.47778 5.83333 2.31944 5.76944 2.19167 5.64167C2.06389 5.51389 2 5.35556 2 5.16667C2 4.97778 2.06389 4.81944 2.19167 4.69167C2.31944 4.56389 2.47778 4.5 2.66667 4.5H13.3333C13.5222 4.5 13.6806 4.56389 13.8083 4.69167C13.9361 4.81944 14 4.97778 14 5.16667C14 5.35556 13.9361 5.51389 13.8083 5.64167C13.6806 5.76944 13.5222 5.83333 13.3333 5.83333H2.66667ZM4.66667 9.16667C4.47778 9.16667 4.31944 9.10278 4.19167 8.975C4.06389 8.84722 4 8.68889 4 8.5C4 8.31111 4.06389 8.15278 4.19167 8.025C4.31944 7.89722 4.47778 7.83333 4.66667 7.83333H11.3333C11.5222 7.83333 11.6806 7.89722 11.8083 8.025C11.9361 8.15278 12 8.31111 12 8.5C12 8.68889 11.9361 8.84722 11.8083 8.975C11.6806 9.10278 11.5222 9.16667 11.3333 9.16667H4.66667Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.26b0f090df492e15aced4d8b22cfd76b.svg";
export { ForwardRef as ReactComponent };